import type { StringGUID } from "@pdfking/tfunc"

import type { TrackedTask } from "./TrackedTask"

export type TrackingInterface = {
  readonly start: (guid: StringGUID) => void
  readonly stop: (guid: StringGUID, error: Error | undefined) => void
  readonly push: (guid: StringGUID, task: TrackedTask) => void
}
